import React, { useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { BASE_URL } from "./Constants";

const Pdf = () => {
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("");
  const [activeButton, setActiveButton] = useState("");

  const downloadPDF = async (apiUrl, fileName, text, buttonId) => {
    try {
      setLoading(true);
      setLoadingText(text);
      setActiveButton(buttonId);

      const response = await fetch(`${BASE_URL}/${apiUrl}`);

      if (!response.ok) {
        throw new Error("API failed");
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed", err);
    } finally {
      setLoading(false);
      setLoadingText("");
      setActiveButton("");
    }
  };

  const buttonStyle = (buttonId) => ({
    margin: "10px",
    padding: "12px 20px",
    backgroundColor:
      loading && activeButton !== buttonId ? "gray" : "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor:
      loading && activeButton !== buttonId
        ? "not-allowed"
        : "pointer",
    fontSize: "16px",
    minWidth: "250px",
    opacity: loading && activeButton !== buttonId ? 0.6 : 1
  });

  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />

        <div className="main-panel">
          <div className="content-wrapper">
            <div style={{ padding: "20px", textAlign: "center" }}>
              
              <h3>Download PMS Reports</h3>

              {/* 0 - 400 */}
              <button
                disabled={loading}
                style={buttonStyle("btn1")}
                onClick={() =>
                  downloadPDF(
                    "download_all_pms_pdf",
                    "PMS_0_400.zip",
                    "Preparing 0 - 400 Reports...",
                    "btn1"
                  )
                }
              >
                {activeButton === "btn1" && loading
                  ? "Preparing..."
                  : "📥 Download 0 - 400 PDF"}
              </button>

              <br />

              {/* 400 - 800 */}
              <button
                disabled={loading}
                style={buttonStyle("btn2")}
                onClick={() =>
                  downloadPDF(
                    "download_all_pms_pdf_2",
                    "PMS_400_800.zip",
                    "Preparing 400 - 800 Reports...",
                    "btn2"
                  )
                }
              >
                {activeButton === "btn2" && loading
                  ? "Preparing..."
                  : "📥 Download 400 - 800 PDF"}
              </button>

              <br />

              {/* 800 - 1200 */}
              <button
                disabled={loading}
                style={buttonStyle("btn3")}
                onClick={() =>
                  downloadPDF(
                    "download_all_pms_pdf_3",
                    "PMS_800_1200.zip",
                    "Preparing 800 - 1200 Reports...",
                    "btn3"
                  )
                }
              >
                {activeButton === "btn3" && loading
                  ? "Preparing..."
                  : "📥 Download 800 - 1200 PDF"}
              </button>

              <br />

              {/* 1200 - Last */}
              <button
                disabled={loading}
                style={buttonStyle("btn4")}
                onClick={() =>
                  downloadPDF(
                    "download_all_pms_pdf_4",
                    "PMS_1200_Last.zip",
                    "Preparing 1200 - Last Reports...",
                    "btn4"
                  )
                }
              >
                {activeButton === "btn4" && loading
                  ? "Preparing..."
                  : "📥 Download 1200 - Last PDF"}
              </button>

              {loading && (
                <p style={{ marginTop: "20px", color: "gray" }}>
                  {loadingText}
                  <br />
                  Please wait for almost 5 mins... Other buttons are disabled until download completes.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pdf;